export default __webpack_public_path__ + "static/media/Aura-Egg__11.13dbff18.png";